<template>
  <div class="sidebar">
    <div v-if="typeTransport === 'verhuizing'">
      <div class="price-row">
        <div class="price-content">
          <h3 class="h1 m-0">Verhuispakket</h3>
        </div>
      </div>

      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Van {{ ophaalAdres.plaatsnaam }}</h3>
          <div class="price-description">
            <p v-if="ophalendatum && ophalenTime">
              {{ ophalenDate }} tussen {{ ophalenTijd }} uur
            </p>
            <p v-if="this.ophalenTime === 'flex'"></p>
            <p v-else>+ € 10,00</p>
          </div>

          <h3 style="margin-top: 15px;" class="h3">
            Naar {{ afleverAdres.plaatsnaam }}
          </h3>
          <div v-if="zelfdedag !== 'ja'" class="price-description">
            <p v-if="afleverdatum && afleverTime">
              {{ afleverDate }} tussen {{ afleverTijd }} uur
            </p>
            <p v-if="this.afleverTime === 'flex'"></p>
            <p v-else>+ € 10,00</p>
          </div>
          <div v-else class="price-description">
            <p v-if="ophalendatum && ophalenTime">
              {{ ophalenDate }} tussen {{ ophalenTijd }} uur
            </p>
            <p></p>
          </div>
        </div>
      </div>

      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-cubes"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Verhuispakket</h3>
          <div class="price-description" v-if="movementPackage">
            <p>{{ movementPackage }} m3</p>
            <p class="price">€ {{ movementPackagePrice }},-</p>
          </div>
        </div>
      </div>

      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-people-carry"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Aantal sjouwers</h3>
          <div class="price-description" v-if="movementPackage && sjouwers > 0">
            <p>{{ sjouwers }} sjouwer(s)</p>
            <p class="price">€ {{ sjouwersPrice }},-</p>
          </div>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-stopwatch"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Aantal gewenste uren (inclusief rijden)</h3>
          <div class="price-description" v-if="movementPackage && uren > 0">
            <p>{{ uren }}</p>
            <p class="price">€ {{ urenPrice }},-</p>
          </div>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-ruler-vertical"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Verhuislift nodig</h3>
          <div class="price-description">
            <p>
              {{ verhuislift === "ja" ? "Ja" : "Nee" }}
            </p>
            <p class="price">
              € {{ verhuislift === "ja" ? `${elevatorPrice},00` : "0,00" }}
            </p>
          </div>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-archive"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Opslag service</h3>
          <div v-if="zelfdedag === 'nee'" class="price-description">
            <p>{{ opslagDagen }} dag(en) opslag</p>
            <p>+ € {{ parseInt(opslagDagen) * 5 }},00</p>
          </div>
        </div>
      </div>

      <template v-if="klant.type === 'zakelijk'">
        <div class="price-row subtotalRow">
          <div class="price-content ml">
            <div class="price-sub">
              <h3 class="h3">Subtotaal</h3>
              <h3 class="h3">
                €
                {{
                  ((totalPriceVerhuizing / 121) * 100)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </h3>
            </div>
            <div class="price-description">
              <p class="h4">15% korting (vast voordeel)</p>
              <p class="h4">
                - €
                {{
                  parseFloat((discountPrice / 121) * 100)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="price-row">
          <div class="price-content ml">
            <div class="price-sub">
              <h3 class="h3">Totaal excl. BTW</h3>
              <h3 class="h3">
                €
                {{
                  ((totalPriceWithDiscount / 121) * 100)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </h3>
            </div>
            <div class="price-description">
              <p>21% BTW</p>
              <p>
                €
                {{
                  ((totalPriceWithDiscount / 121) * 21)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="price-row subtotalRow">
        <div class="price-content ml">
          <div class="price-sub">
            <h3 class="h3">Subtotaal</h3>
            <h3 class="h3">
              €
              {{
                parseFloat(totalPriceVerhuizing)
                  .toFixed(2)
                  .replace(".", ",")
              }}
            </h3>
          </div>
          <div class="price-description" v-if="isBEOrNL">
            <p class="h4">15% korting (vast voordeel)</p>
            <p class="h4">
              - €
              {{
                parseFloat(discountPrice)
                  .toFixed(2)
                  .replace(".", ",")
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="price-sub totalRow ml">
        <h3 class="h3">Te betalen</h3>
        <h1 class="h1">
          €
          {{
            parseFloat(totalPriceWithDiscount)
              .toFixed(2)
              .replace(".", ",")
          }}
        </h1>
      </div>
      <div class="price-sub ml price-sub__right">
        <p class="ml">incl. BTW</p>
      </div>
    </div>

    <div v-else>
      <div class="price-row">
        <div class="price-content">
          <h3 class="h1">Ophaal- en brengservice</h3>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Van {{ ophaalAdres.plaatsnaam }}</h3>
          <div class="price-description">
            <p v-if="type">{{ supplierName }}</p>
            <p></p>
          </div>
          <div class="price-description">
            <p v-if="ophalendatum && ophalenTime">
              {{ ophalenDate }} tussen {{ ophalenTijd }} uur
            </p>
            <p v-if="this.ophalenTime === 'flex'"></p>
            <p v-else>+ € 10,00</p>
          </div>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Naar {{ afleverAdres.plaatsnaam }}</h3>
          <div v-if="zelfdedag !== 'ja'" class="price-description">
            <p v-if="afleverdatum && afleverTime">
              {{ afleverDate }} tussen {{ afleverTijd }} uur
            </p>
            <p v-if="this.afleverTime === 'flex'"></p>
            <p v-else>+ € 10,00</p>
          </div>
          <div v-else class="price-description">
            <p v-if="ophalendatum && ophalenTime">
              {{ ophalenDate }} tussen {{ ophalenTijd }} uur
            </p>
            <p></p>
          </div>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-road"></i>
        </div>
        <div class="price-content afstand">
          <h3 class="h3">Afstand</h3>
          <div v-if="totalKm" class="price-description">
            <p>{{ totalKm }} kilometer</p>
            <p class="price">
              €
              {{
                parseFloat(totalKmPrice)
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i data-v-7d622f5c class="fas fa-people-carry"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Voorwerpen</h3>
          <template v-for="(voorwerp, idx) in voorwerpen">
            <div :key="idx">
              <div v-if="voorwerp.type" class="price-description">
                <p>
                  {{ voorwerp.type }}
                  <span
                    v-if="
                      voorwerp.lengte && voorwerp.hoogte && voorwerp.breedte
                    "
                    >- {{ voorwerp.lengte }}x{{ voorwerp.hoogte }}x{{
                      voorwerp.breedte
                    }}cm</span
                  >
                </p>
                <p v-if="idx === 0" class="price">+ € 0,00</p>
                <p v-else class="price">+ € 20,00</p>
              </div>
              <div
                v-if="voorwerp.koerier === 'ja' && idx === 0"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Extra hulp</p>
                <p class="price">+ € 50,00</p>
              </div>
              <div
                v-if="voorwerp.gewicht == '35-79kg' && idx === 0"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Extra gewicht</p>
                <p class="price">+ € 50,00</p>
              </div>
              <div
                v-if="voorwerp.gewicht == 'groterdan200kg' && idx === 0"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Extra gewicht</p>
                <p class="price">+ € 150,00</p>
              </div>
              <div
                v-if="voorwerp.gewicht == '80-200kg' && idx === 0"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Extra gewicht</p>
                <p class="price">+ € 100,00</p>
              </div>
              <div
                v-if="voorwerp.oudspulmeenemen === 'ja'"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Oude spullen meenemen</p>
                <p class="price">+ € 48,00</p>
              </div>
              <div
                v-if="voorwerp.demontagemontage === 'ja'"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Demontage / montage</p>
                <p class="price">+ € 40,00</p>
              </div>
              <div
                v-if="voorwerp.packing === 'ja'"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Inpakken</p>
                <p class="price">+ € 39,00</p>
              </div>
              <div
                v-if="verhuislift === 'ja' && idx === 0"
                class="price-description"
                style="margin-left: 20px;"
              >
                <p>Verhuislift</p>
                <p class="price">+ € {{ elevatorPrice }},00</p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="price-row">
        <div class="price-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="price-content">
          <h3 class="h3">Opslag service</h3>
          <div v-if="zelfdedag === 'nee'" class="price-description">
            <p>{{ opslagDagen }} dag(en) opslag</p>
            <p>+ € {{ parseInt(opslagDagen) * 5 }},00</p>
          </div>
        </div>
      </div>

      <template v-if="klant.type === 'zakelijk'">
        <div class="price-row subtotalRow">
          <div class="price-content ml border-light">
            <div class="price-sub">
              <h3 class="h3">Subtotaal</h3>
              <h3 class="h3">
                € {{ ((totalPrice / 121) * 100).toFixed(2).replace(".", ",") }}
              </h3>
            </div>
            <div class="price-description" v-if="isBEOrNL">
              <p class="h4">15% korting (vast voordeel)</p>
              <p class="h4">
                - €
                {{
                  parseFloat((discountPrice / 121) * 100)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="price-row">
          <div class="price-content ml">
            <div class="price-sub">
              <h3 class="h3">Totaal excl. BTW</h3>
              <h3 class="h3">
                €
                {{
                  ((totalPriceWithDiscount / 121) * 100)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </h3>
            </div>
            <div class="price-description">
              <p>21% BTW</p>
              <p>
                €
                {{
                  ((totalPriceWithDiscount / 121) * 21)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="price-row subtotalRow">
        <div class="price-content ml border-light">
          <div class="price-sub">
            <h3 class="h3">Subtotaal</h3>
            <h3 class="h3">
              €
              {{
                parseFloat(totalPrice)
                  .toFixed(2)
                  .replace(".", ",")
              }}
            </h3>
          </div>
          <div class="price-description" v-if="isBEOrNL">
            <p class="h4">15% korting (vast voordeel)</p>
            <p class="h4">
              - €
              {{
                parseFloat(discountPrice)
                  .toFixed(2)
                  .replace(".", ",")
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="price-sub totalRow ml">
        <h3 class="h3">Te betalen</h3>
        <h1 class="h1">
          €
          {{
            parseFloat(totalPriceWithDiscount)
              .toFixed(2)
              .replace(".", ",")
          }}
        </h1>
      </div>
      <div class="price-sub ml price-sub__right">
        <p class="ml">incl. BTW</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "Sidebar",
  computed: {
    ...mapFields([
      "movementPackage",
      "sjouwers",
      "placement",
      "verdieping",
      "uren",
      "verhuislift",
      "typeTransport",
      "ophaalAdres",
      "afleverAdres",
      "voorwerpen",
      "totalKm",
      "ophalen",
      "ophalenTime",
      "afleverTime",
      "ophalendatum",
      "afleverdatum",
      "zelfdedag",
      "klant",
      "checkoutPrice",
      "type",
      "extraCountryCosts",
      "isBEOrNL"
    ]),
    supplierName() {
      let suppliers = {
        woning: "Vanaf een woning",
        "2dehands": "Via marktplaats",
        winkel: "Vanaf een winkel/bedrijf",
        veiling: "Vanaf een veiling"
      };

      if (this.type) {
        return suppliers[this.type];
      }

      return null;
    },
    totalPriceVerhuizing() {
      let totalprice = 0;
      if (this.totalKm === null) {
        return totalprice;
      }

      if (this.movementPackagePrice) {
        totalprice =
          this.movementPackagePrice +
          this.sjouwersPrice +
          this.elevatorPrice +
          this.urenPrice +
          parseInt(this.opslagDagen) * 5;
      }

      return totalprice;
    },
    totalPrice() {
      if (this.totalKm === null) {
        return 0;
      }

      return (
        this.totalVoorwerpenPrice +
        this.totalKmPrice +
        this.elevatorPrice +
        this.timesPrices +
        parseInt(this.opslagDagen) * 5
      );
    },
    discountPrice() {
      let discount = 0.15;
      if (!this.isBEOrNL) {
        discount = 0;
      }

      if (this.typeTransport === "verhuizing") {
        return this.totalPriceVerhuizing * discount;
      }
      return this.totalPrice * discount;
    },
    totalPriceWithDiscount() {
      if (this.typeTransport === "verhuizing") {
        return this.totalPriceVerhuizing - this.discountPrice;
      }
      return this.totalPrice - this.discountPrice;
    },
    opslagDagen() {
      let dagen = 0;

      if (this.zelfdedag === "nee") {
        let dateString = this.ophalendatum;

        if (dateString === null || this.afleverdatum === null) {
          return;
        }
        let dateParts = dateString.split("-");
        let ophalen = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

        let dateStringTwo = this.afleverdatum;

        let datePartsTwo = dateStringTwo.split("-");
        let aflever = new Date(
          +datePartsTwo[2],
          datePartsTwo[1] - 1,
          +datePartsTwo[0]
        );

        // To calculate the time difference of two dates
        let Difference_In_Time = aflever.getTime() - ophalen.getTime();

        // To calculate the no. of days between two dates
        dagen = Difference_In_Time / (1000 * 3600 * 24);
      }

      return dagen;
    },
    ophalenDate() {
      let dateString = this.ophalendatum;

      if (dateString === null) {
        return;
      }

      let dateParts = dateString.split("-");
      let date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      let day = dateParts[0];
      let month = this.months[date.getMonth()];

      return day + " " + month;
    },
    afleverDate() {
      let dateString = this.afleverdatum;

      if (dateString === null) {
        return;
      }

      let dateParts = dateString.split("-");
      let date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      let day = dateParts[0];
      let month = this.months[date.getMonth()];

      return day + " " + month;
    },
    ophalenTijd() {
      if (this.ophalenTime === "flex") {
        return "9:00 - 18:00";
      }

      return this.ophalenTime;
    },
    afleverTijd() {
      if (this.afleverTime === "flex") {
        return "9:00 - 18:00";
      }

      return this.afleverTime;
    },
    timesPrices() {
      let price = 0;
      if (this.ophalenTime !== "flex") {
        price += 10;
      }

      if (this.zelfdedag === "ja") {
        return price;
      }

      if (this.afleverTime !== "flex") {
        price += 10;
      }

      return price;
    },
    months() {
      return [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ];
    },
    totalKmPrice() {
      if (this.totalKm <= 30) {
        if (this.extraCountryCosts) return 110;
        return 80;
      } else if (this.totalKm <= 50) {
        if (this.extraCountryCosts) return 130;
        return 100;
      } else {
        let km = Math.round(this.totalKm) - 70;
        let price = this.extraCountryCosts ? 150 : 120;
        let kmPrice = this.isBEOrNL ? 0.28 : 0.88;

        if (km > 0) {
          price = price + km * kmPrice;
        }

        return price;
      }
    },
    movementPackagePrice() {
      if (this.movementPackage == "") return 0;

      if (this.movementPackage == 20) {
        return 141;
      } else if (this.movementPackage == 40) {
        return 332;
      } else {
        return 523;
      }
    },
    sjouwersPrice() {
      if (this.movementPackage == "") return 0;

      let price = 90;
      let sjouwers = 3;
      if (this.movementPackage == 20) {
        sjouwers = 1;
      } else if (this.movementPackage == 40) {
        sjouwers = 2;
      }

      return parseInt(`${price * (this.sjouwers - sjouwers)}`);
    },
    urenPrice() {
      if (this.movementPackage == "") return 0;

      let uurTarief = 90;
      if (this.movementPackage == 40) {
        uurTarief = 180;
      } else if (this.movementPackage == 57) {
        uurTarief = 270;
      }

      return parseInt(`${uurTarief * (this.uren - 1)}`);
    },
    elevatorPrice() {
      if (this.verhuislift === "ja") {
        if (this.typeTransport === "verhuizing") {
          return 175;
        }
        return 149;
      }

      return 0;
    },
    placementPrice() {
      if (this.verdieping < 3) {
        return 0;
      }

      return 0;
    },
    totalVoorwerpenPrice() {
      let price = 0;
      if (this.voorwerpen.length > 0) {
        this.voorwerpen.map((voorwerp, idx) => {
          price += this.getPrice(voorwerp, idx);
        });
      }

      return price;
    }
  },
  methods: {
    getPrice(voorwerp, idx) {
      let price = 0;

      if (idx !== 0) {
        price += 20;
      }

      if (voorwerp.gewicht == "35-79kg") {
        price += 50;
      } else if (voorwerp.gewicht == "80-200kg") {
        price += 100;
      } else if (voorwerp.gewicht == "groterdan200kg") {
        price += 150;
      }

      if (voorwerp.koerier == "ja") {
        price += 50;
      }

      if (voorwerp.oudspulmeenemen == "ja") {
        price += 80;
      }

      if (voorwerp.demontagemontage == "ja") {
        price += 40;
      }

      if (voorwerp.packing == "ja") {
        price += 39;
      }

      return price;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  padding: 10px 30px 50px 30px;
  @media only screen and (max-width: 890px) {
    width: 100%;
    overflow-y: scroll;
  }

  .h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .h4 {
    font-size: 16px;
  }

  .m-0 {
    margin: 0;
  }
}
.price-content h3.h1 {
  margin-top: 25px;
}

.price {
  &-row {
    display: flex;
    margin-bottom: 8px;
  }

  &-sub {
    display: flex;
    justify-content: space-between;

    &.ml {
      margin-left: 80px;
      align-items: center;

      .h1,
      .h3 {
        margin: 0;
      }
    }

    &__right {
      p {
        margin: 0 0 0 auto;
      }
    }
  }

  &-description {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
  }

  &-icon {
    display: flex;
    height: 30px;
    width: 30px;
    margin-right: 10px;
    margin-top: 7px;
    font-size: 18px;
  }

  &-content {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-bottom: 8px;

    &.ml {
      margin-left: 80px;
      border-bottom: 2px solid var(--black);

      &.border-light {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      }
    }

    .h3 {
      margin: 0;
    }

    p {
      margin: 0;
      font-size: 14px;
      line-height: 30px;
    }
  }
}
</style>
